import { css } from 'styled-system/css';
import { flex } from 'styled-system/patterns';

export const styles = {
	container: flex({
		_mars: {
			position: 'relative',
			justifyContent: 'space-between',
			alignItems: 'center',
			color: 'league.collapseText',
			bg: 'league.collapseBg',
			p: '6px 6px 6px 12px',
			fontSize: '12px',
			borderTopLeftRadius: '6px',
			borderTopRightRadius: '6px',
			cursor: 'pointer',
			_before: {
				content: '""',
				display: 'block',
				position: 'absolute',
				top: 0,
				right: '40px',
				backgroundImage: 'url(/images/collapse_league_bg.svg)',
				w: '95px',
				h: '27px',
			},
			'& .icon': {
				w: '20px',
				h: '20px',
			},
			md: {
				display: 'none',
			},
		}
	}),
	text: css({
		_mars: {
			color: 'currentColor'
		}
	}),
}